<template>
  <div class="m-5 bg-white flex flex-wrap flex-col justify-center items-center text-center">
    <img :src="require('@/assets/shipo-sales-plan-no-data.svg')">
    <span class="mb-5 font-medium text-base">
      BLU successfully submitted!
    </span>
    <p class="mb-2 secondary-text">
      {{ newBLU }} new BLU created
    </p>
    <div class="mt-5 flex justify-center gap-3">
      <vs-button
        class="button shadow-primary font-semibold"
        color="primary"
        @click="() => $router.push('/barge-line-up/list')"
      >
        View BLU
      </vs-button>
      <vs-button
        type="border"
        class="button shadow-primary font-semibold"
        color="primary"
        @click="() => $router.push('/barge-line-up/list/upload')"
      >
        Upload Another BLU Plan
      </vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    newBLU: 0
  }),
  mounted() {
    this.newBLU = this.$route.query.n
  }
}
</script>

<style lang="scss" scoped>
.secondary-text {
  color: #9E9E9E;
}
</style>
